<script lang="ts">
import {Vue, Component} from 'vue-facing-decorator';
import {useUserStore} from "@/stores/userStore";
import {useAppStore} from "@/stores/appStore";
import {useDisplay} from "vuetify";

@Component({
  components: {}
})
export default class Admin extends Vue {
  private userStore = useUserStore();
  private mdAndUp = useDisplay().mdAndUp;
  private appStore = useAppStore();
  private activeTab = 0;
}
</script>

<template>
  <div class="fill-height embed-container overflow-x-hidden">
    <v-app-bar height="64" flat>
      <v-tabs v-if="mdAndUp" bg-color="background" color="primary" class="header-tabs">
        <v-tab slider-color="transparent" disabled class="enabled"><v-icon start>mdi-shield-account-outline</v-icon> Administration</v-tab>
      </v-tabs>
      <v-tabs align-tabs="center" bg-color="background" color="primary" class="menu-tabs" :style="mdAndUp ? 'margin-left: -450px' : 'margin-left: 0'">
        <v-tab exact :to="{ name: 'accounts' }">Accounts</v-tab>
        <v-tab :to="{ name: 'superusers' }">Super users</v-tab>
        <v-tab :to="{ name: 'application-management' }">Applications</v-tab>
        <v-tab :to="{ name: 'system-groups' }">System groups</v-tab>
        <v-tab :to="{ name: 'quicksight-users' }" v-if="appStore.debugMode">Quicksight Access</v-tab>
        <v-tab :to="{ name: 'nodered-management' }" v-if="appStore.debugMode">Node-Red</v-tab>
      </v-tabs>
    </v-app-bar>
    <v-card variant="flat" class="rounded-0 pa-0 fill-height">
      <v-window class="fill-height">
        <v-window-item class="fill-height">
          <router-view />
        </v-window-item>
      </v-window>
    </v-card>
  </div>
</template>

<style>
.enabled {
  opacity: 1 !important;
}
.header-tabs {
  width: 450px;
}
.menu-tabs {
  width: 100%;
}
</style>
